module.exports = {
  "country": "CZ",
  "artist": "Mikolas Josef",
  "song": "Lie to Me",
  "year": "2018",
  "place": "6",
  "spotify": "5bCztCNsrQPQ2yvLUaMCMa"
};